import { z } from 'zod';

export const languageSchema = z.enum(['ru', 'en']);
export type Language = z.infer<typeof languageSchema>;

export const articleSummarySchema = z.object({
  id: z.string().min(1),
  lang: languageSchema,
  title: z.string().min(1),
  displayTitle: z.string().min(1),
  description: z.string().min(1).optional(),
  extract: z.string().min(1),
  thumbnailUrl: z.url().optional(),
  originalImageUrl: z.url().optional(),
  wikipediaUrl: z.url(),
});

export type ArticleSummary = z.infer<typeof articleSummarySchema>;

export const articleSharePayloadSchema = z.object({
  lang: languageSchema,
  title: z.string().min(1).max(300),
});

export const journeySharePayloadSchema = z.object({
  lang: languageSchema,
  titles: z.array(z.string().min(1).max(300)).min(1).max(50),
  currentTitle: z.string().min(1).max(300),
});

export const createShareSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('article'), payload: articleSharePayloadSchema }),
  z.object({ kind: z.literal('journey'), payload: journeySharePayloadSchema }),
]);

export type CreateShareInput = z.infer<typeof createShareSchema>;
export type ShareRecord = CreateShareInput & {
  id: string;
  createdAt: string;
  expiresAt: string;
};

export interface ShareResponse {
  id: string;
  deepLink: string;
  webLink: string;
}

export interface ExplorationLevel {
  anchor: ArticleSummary | null;
  items: ArticleSummary[];
  index: number;
  exhausted?: boolean;
}

export interface ExplorationState {
  levels: ExplorationLevel[];
  journey: ArticleSummary[];
}

export interface ApiErrorBody {
  error: string;
  message: string;
}
